import _styled from "@emotion/styled-base";
import * as React from "react";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { allProps } from "./css";

var Box = /*#__PURE__*/_styled("div", {
  shouldForwardProp: shouldForwardProp,
  target: "e1d2lsqg0"
})(allProps);

Box.displayName = "Box";
export default Box;